import flashUltra from '../assets/tiles/promo/spingo-promo-1m-flash.png';
import holdemUltra from '../assets/tiles/promo/spingo-promo-1m-holdem.png';
import flashHigh from '../assets/tiles/spingo-flash-high.png';
import flashLow from '../assets/tiles/spingo-flash-low.png';
import flashMedium from '../assets/tiles/spingo-flash-medium.png';
import flashMicro from '../assets/tiles/spingo-flash-micro.png';
import holdemHigh from '../assets/tiles/spingo-holdem-high.png';
import holdemLow from '../assets/tiles/spingo-holdem-low.png';
import holdemMedium from '../assets/tiles/spingo-holdem-medium.png';
import holdemMicro from '../assets/tiles/spingo-holdem-micro.png';
import maxHigh from '../assets/tiles/spingo-max-high.png';
import maxLow from '../assets/tiles/spingo-max-low.png';
import maxMedium from '../assets/tiles/spingo-max-medium.png';
import maxMicro from '../assets/tiles/spingo-max-micro.png';
import omahaHigh from '../assets/tiles/spingo-omaha-high.png';
import omahaLow from '../assets/tiles/spingo-omaha-low.png';
import omahaMedium from '../assets/tiles/spingo-omaha-medium.png';
import omahaMicro from '../assets/tiles/spingo-omaha-micro.png';
import { ENDPOINTS } from '../constants';
import type { GameTypeName, GameTypeUrl } from '../types/Game';
import { GAME_TYPE_URL_MAP, GameStake, GameType } from '../types/Game';

const HOLDEM = 'spingo--holdem-';
const FLASH = 'spingo--flash-';
const MAX = 'spingo--max-';
const OMAHA = 'spingo--omaha-';

export const DEFAULT_PROMO_IMAGE = {
  [GameType.Holdem]: holdemUltra,
  [GameType.HoldemFlash]: flashUltra,
  [GameType.Omaha]: omahaHigh,
  [GameType.HoldemMax]: maxHigh
};

const getPromoAsset = (promoRef: string, locale: string) => {
  const searchParams = new URLSearchParams({ promoRef, locale });

  return ENDPOINTS.tileBackground + `?${searchParams.toString()}`;
};

const GAME_STAKE_URL_MAP = {
  [GameType.Holdem]: {
    [`${HOLDEM}${GameStake.MICRO}`]: holdemMicro,
    [`${HOLDEM}${GameStake.LOW}`]: holdemLow,
    [`${HOLDEM}${GameStake.MEDIUM}`]: holdemMedium,
    [`${HOLDEM}${GameStake.HIGH}`]: holdemHigh,
    [`${HOLDEM}${GameStake.ULTRA}`]: holdemUltra,
    default: holdemLow
  },
  [GameType.HoldemFlash]: {
    [`${FLASH}${GameStake.MICRO}`]: flashMicro,
    [`${FLASH}${GameStake.LOW}`]: flashLow,
    [`${FLASH}${GameStake.MEDIUM}`]: flashMedium,
    [`${FLASH}${GameStake.HIGH}`]: flashHigh,
    [`${FLASH}${GameStake.ULTRA}`]: flashUltra,
    default: flashLow
  },
  [GameType.HoldemMax]: {
    [`${MAX}${GameStake.MICRO}`]: maxMicro,
    [`${MAX}${GameStake.LOW}`]: maxLow,
    [`${MAX}${GameStake.MEDIUM}`]: maxMedium,
    [`${MAX}${GameStake.HIGH}`]: maxHigh,
    [`${MAX}${GameStake.ULTRA}`]: maxHigh,
    default: maxLow
  },
  [GameType.Omaha]: {
    [`${OMAHA}${GameStake.MICRO}`]: omahaMicro,
    [`${OMAHA}${GameStake.LOW}`]: omahaLow,
    [`${OMAHA}${GameStake.MEDIUM}`]: omahaMedium,
    [`${OMAHA}${GameStake.HIGH}`]: omahaHigh,
    [`${OMAHA}${GameStake.ULTRA}`]: omahaHigh,
    default: omahaLow
  }
};

export const getBackground = (
  url: GameTypeUrl,
  gameType: GameTypeName,
  isUltra: boolean,
  locale: string,
  promoRef?: string
) =>
  promoRef && !isUltra
    ? getPromoAsset(promoRef, locale)
    : GAME_STAKE_URL_MAP[gameType][url[GAME_TYPE_URL_MAP[gameType]]] ||
      GAME_STAKE_URL_MAP[gameType].default;
